import React, { useState } from 'react';
import { API_URL as API_BASE_URL } from '../config/api';
import {
    FaUser,
    FaBuilding,
    FaTimes,
    FaCheckCircle,
    FaUpload,
    FaLinkedin,
    FaGlobe,
    FaFileAlt,
    FaBriefcase,
    FaMapMarkerAlt,
    FaCalendar,
    FaEnvelope,
    FaSpinner
} from 'react-icons/fa';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Header from '../components/Header';
import Footer from '../components/Footer';


const FormPartners = () => {
    const [showModal, setShowModal] = useState(true);
    const [selectedType, setSelectedType] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showAutreDomaine, setShowAutreDomaine] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isChangingProfile, setIsChangingProfile] = useState(false);
    const [formData, setFormData] = useState({
        // Consultant fields
        nom: '',
        prenom: '',
        pays: '',
        telephone: '',
        email: '',
        domaineExercice: '',
        autreDomaine: '',
        ville: '',
        quartier: '',
        anneesExperience: '',
        cv: null,
        linkedinConsultant: '',

        // Entreprise fields
        nomEntreprise: '',
        nomRepresentant: '',
        dateCreation: '',
        paysEntreprise: '',
        villeEntreprise: '',
        motivation: '',
        linkedinEntreprise: '',
        siteWeb: '',
        preuveExistence: null
    });

    const handleTypeSelection = (type) => {
        // Réinitialiser complètement le formulaire lors du changement de profil
        setFormData({
            nom: '',
            prenom: '',
            pays: '',
            telephone: '',
            email: '',
            domaineExercice: '',
            autreDomaine: '',
            ville: '',
            quartier: '',
            anneesExperience: '',
            cv: null,
            linkedinConsultant: '',
            nomEntreprise: '',
            nomRepresentant: '',
            dateCreation: '',
            paysEntreprise: '',
            villeEntreprise: '',
            motivation: '',
            linkedinEntreprise: '',
            siteWeb: '',
            preuveExistence: null
        });
        setShowAutreDomaine(false);
        setSelectedType(type);
        setShowModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Gérer l'affichage du champ "Autre domaine"
        if (name === 'domaineExercice') {
            setShowAutreDomaine(value === 'autre');
        }

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePhoneChange = (value) => {
        setFormData(prev => ({
            ...prev,
            telephone: value
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files && files[0]) {
            setFormData(prev => ({
                ...prev,
                [name]: files[0]
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            setIsLoading(true);
            
            // Convertir 'entreprise' en 'cabinet' pour le backend
            const backendProfileType = selectedType === 'entreprise' ? 'cabinet' : 'consultant';
            
            // Vérifier que le téléphone et l'email sont bien remplis
            if (!formData.telephone || !formData.email) {
                alert('Veuillez remplir le téléphone et l\'email');
                setIsLoading(false);
                return;
            }

            console.log('=== ÉTAPE 1: Création application ===');
            console.log('Profile type:', backendProfileType);
            console.log('Email:', formData.email);
            console.log('Téléphone:', formData.telephone);
            
            // Étape 1 : Créer l'application partenaire
            const applicationResponse = await fetch(`${API_BASE_URL}/partner-applications`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    profile_type: backendProfileType,
                    email: formData.email,
                    phone_full: formData.telephone,
                }),
            });

            if (!applicationResponse.ok) {
                const errorData = await applicationResponse.json();
                console.error('Erreur API:', errorData);
                throw new Error('Erreur lors de la création de l\'application');
            }

            const application = await applicationResponse.json();
            const applicationId = application.id;
            console.log('Application créée avec ID:', applicationId);

            // Étape 2 : Enregistrer le profil (Consultant ou Entreprise)
            if (backendProfileType === 'consultant') {
                console.log('=== ÉTAPE 2: Création profil consultant ===');
                
                const consultantData = {
                    first_name: formData.prenom,
                    last_name: formData.nom,
                    country: formData.pays,
                    city: formData.ville,
                    district: formData.quartier,
                    professional_domain: formData.domaineExercice,
                    other_domain: formData.autreDomaine || null,
                    years_of_experience: parseInt(formData.anneesExperience),
                    linkedin_url: formData.linkedinConsultant,
                };
                
                console.log('Données consultant:', consultantData);
                
                const consultantResponse = await fetch(`${API_BASE_URL}/partner-applications/${applicationId}/consultant`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify(consultantData),
                });

                if (!consultantResponse.ok) {
                    const errorData = await consultantResponse.json();
                    console.error('Erreur profil consultant:', errorData);
                    throw new Error('Erreur lors de l\'enregistrement du profil consultant');
                }

                console.log('Profil consultant créé avec succès');

                // Étape 3 : Upload du CV
                if (formData.cv) {
                    console.log('=== ÉTAPE 3: Upload CV ===');
                    
                    const cvFormData = new FormData();
                    cvFormData.append('type', 'cv');
                    cvFormData.append('file', formData.cv);

                    const cvResponse = await fetch(`${API_BASE_URL}/partner-applications/${applicationId}/documents`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                        },
                        body: cvFormData,
                    });

                    if (!cvResponse.ok) {
                        const errorData = await cvResponse.json();
                        console.error('Erreur upload CV:', errorData);
                        throw new Error('Erreur lors de l\'upload du CV');
                    }
                    
                    console.log('CV uploadé avec succès');
                }
            } else {
                console.log('=== ÉTAPE 2: Création profil entreprise ===');
                
                const companyData = {
                    company_name: formData.nomEntreprise,
                    representative_name: formData.nomRepresentant,
                    founded_at: formData.dateCreation,
                    country: formData.paysEntreprise,
                    city: formData.villeEntreprise,
                    motivation: formData.motivation,
                    linkedin_url: formData.linkedinEntreprise,
                    website_url: formData.siteWeb || null,
                };
                
                console.log('Données entreprise:', companyData);
                
                const companyResponse = await fetch(`${API_BASE_URL}/partner-applications/${applicationId}/company`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify(companyData),
                });

                if (!companyResponse.ok) {
                    const errorData = await companyResponse.json();
                    console.error('Erreur profil entreprise:', errorData);
                    throw new Error('Erreur lors de l\'enregistrement du profil entreprise');
                }

                console.log('Profil entreprise créé avec succès');

                // Étape 3 : Upload de la preuve d'existence
                if (formData.preuveExistence) {
                    console.log('=== ÉTAPE 3: Upload preuve existence ===');
                    
                    const docFormData = new FormData();
                    docFormData.append('type', 'registry');
                    docFormData.append('file', formData.preuveExistence);

                    const docResponse = await fetch(`${API_BASE_URL}/partner-applications/${applicationId}/documents`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                        },
                        body: docFormData,
                    });

                    if (!docResponse.ok) {
                        const errorData = await docResponse.json();
                        console.error('Erreur upload document:', errorData);
                        throw new Error('Erreur lors de l\'upload du document');
                    }
                    
                    console.log('Document uploadé avec succès');
                }
            }

            // Étape 4 : Soumettre la candidature
            console.log('=== ÉTAPE 4: Soumission finale ===');
            
            const submitResponse = await fetch(`${API_BASE_URL}/partner-applications/${applicationId}/submit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });

            if (!submitResponse.ok) {
                const errorData = await submitResponse.json();
                console.error('Erreur soumission:', errorData);
                throw new Error('Erreur lors de la soumission de la candidature');
            }

            console.log('=== SUCCÈS COMPLET ===');
            
            // Succès
            setFormSubmitted(true);
            setIsLoading(false);

            setTimeout(() => {
                setFormSubmitted(false);
                setFormData({
                    nom: '',
                    prenom: '',
                    pays: '',
                    telephone: '',
                    email: '',
                    domaineExercice: '',
                    autreDomaine: '',
                    ville: '',
                    quartier: '',
                    anneesExperience: '',
                    cv: null,
                    linkedinConsultant: '',
                    nomEntreprise: '',
                    nomRepresentant: '',
                    dateCreation: '',
                    paysEntreprise: '',
                    villeEntreprise: '',
                    motivation: '',
                    linkedinEntreprise: '',
                    siteWeb: '',
                    preuveExistence: null
                });
                setShowAutreDomaine(false);
            }, 3000);

        } catch (error) {
            console.error('=== ERREUR GLOBALE ===');
            console.error('Erreur:', error);
            setIsLoading(false);
            alert('Une erreur est survenue lors de l\'envoi du formulaire. Consultez la console pour plus de détails.');
        }
    };

    const handleChangeProfile = async () => {
        setIsChangingProfile(true);
        // Petite pause pour que le loading soit visible
        await new Promise(resolve => setTimeout(resolve, 500));
        setSelectedType(null);
        setShowModal(true);
        // Réinitialiser le formulaire
        setFormData({
            nom: '',
            prenom: '',
            pays: '',
            telephone: '',
            email: '',
            domaineExercice: '',
            autreDomaine: '',
            ville: '',
            quartier: '',
            anneesExperience: '',
            cv: null,
            linkedinConsultant: '',
            nomEntreprise: '',
            nomRepresentant: '',
            dateCreation: '',
            paysEntreprise: '',
            villeEntreprise: '',
            motivation: '',
            linkedinEntreprise: '',
            siteWeb: '',
            preuveExistence: null
        });
        setShowAutreDomaine(false);
        setIsChangingProfile(false);
    };

    const paysList = [
        { code: 'BJ', name: 'Bénin' },
        { code: 'TG', name: 'Togo' },
        { code: 'NE', name: 'Niger' },
        { code: 'CI', name: 'Côte d\'Ivoire' },
        { code: 'SN', name: 'Sénégal' },
        { code: 'ML', name: 'Mali' },
        { code: 'BF', name: 'Burkina Faso' },
        { code: 'GA', name: 'Gabon' },
        { code: 'CM', name: 'Cameroun' },
        { code: 'CG', name: 'Congo' },
        { code: 'CD', name: 'RD Congo' },
        { code: 'CF', name: 'Centrafrique' },
        { code: 'TD', name: 'Tchad' },
        { code: 'GN', name: 'Guinée' },
        { code: 'MR', name: 'Mauritanie' },
        { code: 'MA', name: 'Maroc' },
        { code: 'DZ', name: 'Algérie' },
        { code: 'TN', name: 'Tunisie' },
        { code: 'EG', name: 'Égypte' },
        { code: 'GH', name: 'Ghana' },
        { code: 'NG', name: 'Nigeria' },
        { code: 'KE', name: 'Kenya' },
        { code: 'ZA', name: 'Afrique du Sud' },
        { code: 'FR', name: 'France' },
        { code: 'CA', name: 'Canada' },
        { code: 'US', name: 'États-Unis' },
    ];

    return (
        <>
            <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .devenir-partenaire-wrapper {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: #ffffff;
          min-height: 100vh;
        }

        .devenir-partenaire-wrapper .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.75);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .modal-content {
          background: white;
          border-radius: 24px;
          padding: 48px;
          max-width: 900px;
          width: 100%;
          position: relative;
          animation: modalSlideIn 0.4s ease-out;
        }

        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-close {
          position: absolute;
          top: 20px;
          right: 20px;
          background: #f7fafc;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 18px;
          color: #4a5568;
        }

        .modal-close:hover {
          background: #e2e8f0;
          transform: rotate(90deg);
        }

        .modal-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .modal-header h2 {
          font-size: 36px;
          font-weight: 900;
          color: #1a202c;
          margin-bottom: 12px;
          letter-spacing: -1px;
        }

        .modal-header p {
          font-size: 18px;
          color: #718096;
          font-weight: 500;
        }

        .selection-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
        }

        .selection-card {
          background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
          border: 2px solid #e2e8f0;
          border-radius: 20px;
          padding: 40px 32px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .selection-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          border-color: transparent;
        }

        .card-icon {
          width: 80px;
          height: 80px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
          font-size: 32px;
          color: white;
        }

        .consultant-icon {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
        }

        .entreprise-icon {
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
        }

        .selection-card h3 {
          font-size: 24px;
          font-weight: 800;
          color: #1a202c;
          margin-bottom: 12px;
        }

        .selection-card p {
          font-size: 16px;
          color: #718096;
          line-height: 1.6;
          margin-bottom: 24px;
          font-weight: 500;
        }

        .select-btn {
          width: 100%;
          padding: 14px 24px;
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          color: #1a202c;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .selection-card:hover .select-btn {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          border-color: transparent;
          color: white;
        }

        /* Success Message */
        .success-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .success-message {
          background: white;
          border-radius: 24px;
          padding: 64px 48px;
          text-align: center;
          max-width: 500px;
          animation: successPop 0.5s ease;
        }

        @keyframes successPop {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        .success-icon {
          font-size: 80px;
          color: #198754;
          margin-bottom: 24px;
        }

        .success-message h3 {
          font-size: 28px;
          font-weight: 800;
          color: #1a202c;
          margin-bottom: 12px;
        }

        .success-message p {
          font-size: 17px;
          color: #718096;
          line-height: 1.6;
          font-weight: 500;
        }

        /* Hero Section */
        .partner-hero {
          position: relative;
          padding: 140px 0 80px;
          background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
          overflow: hidden;
        }

        .hero-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 0;
        }

        .floating-shape {
          position: absolute;
          border-radius: 50%;
          opacity: 0.08;
          animation: float 20s ease-in-out infinite;
        }

        .shape-1 {
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          top: -100px;
          right: -100px;
        }

        .shape-2 {
          width: 300px;
          height: 300px;
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          bottom: -50px;
          left: -50px;
          animation-delay: 5s;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) rotate(0deg);
          }
          33% {
            transform: translate(30px, -30px) rotate(120deg);
          }
          66% {
            transform: translate(-20px, 20px) rotate(240deg);
          }
        }

        .hero-content {
          position: relative;
          z-index: 1;
          text-align: center;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 12px 24px;
          background: white;
          border-radius: 50px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 32px;
          font-size: 15px;
          font-weight: 600;
          color: #fd7e14;
        }

        .hero-title {
          font-size: 56px;
          font-weight: 900;
          line-height: 1.1;
          color: #1a202c;
          margin-bottom: 24px;
          letter-spacing: -2px;
        }

        .hero-description {
          font-size: 20px;
          line-height: 1.7;
          color: #4a5568;
          max-width: 700px;
          margin: 0 auto;
          font-weight: 500;
        }

        /* Form Section */
        .form-section {
          padding: 80px 0 100px;
          background: white;
          margin-top: -80px;
        }

        .form-container {
          max-width: 1000px;
          margin: 0 auto;
          background: white;
          border-radius: 24px;
          border: 2px solid #e2e8f0;
          padding: 56px;
        }

        .form-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .form-header h2 {
          font-size: 36px;
          font-weight: 900;
          color: #1a202c;
          margin-bottom: 12px;
          letter-spacing: -1px;
        }

        .form-header p {
          font-size: 18px;
          color: #718096;
          font-weight: 500;
        }

        .partner-form {
          display: flex;
          flex-direction: column;
          gap: 36px;
        }

        .form-section-title {
          display: flex;
          align-items: center;
          gap: 14px;
          padding-bottom: 18px;
          border-bottom: 2px solid #e2e8f0;
          color: #fd7e14;
          font-size: 22px;
          font-weight: 700;
          margin-top: 20px;
        }

        .form-section-title svg {
          font-size: 24px;
        }

        .form-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 28px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .form-group label {
          font-size: 16px;
          font-weight: 600;
          color: #2d3748;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .label-icon {
          color: #fd7e14;
          font-size: 18px;
        }

        .required {
          color: #dc3545;
          font-size: 18px;
        }

        .form-group input,
        .form-group select,
        .form-group textarea {
          padding: 16px 18px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 16px;
          font-family: inherit;
          transition: all 0.3s ease;
          background: white;
          color: #2d3748;
          font-weight: 500;
        }

        .form-group input:focus,
        .form-group select:focus,
        .form-group textarea:focus {
          outline: none;
          border-color: #fd7e14;
          box-shadow: 0 0 0 3px rgba(253, 126, 20, 0.1);
        }

        .form-group textarea {
          resize: vertical;
          min-height: 140px;
          line-height: 1.6;
        }

        /* Country Select with Flag */
        .country-select-wrapper {
          position: relative;
        }

        .country-select {
          appearance: none;
           padding: 16px 45px 16px 18px;
          text-indent: 60px;  
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 16px;
          font-family: inherit;
          transition: all 0.3s ease;
          background: white url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%234a5568' d='M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6z'/%3E%3C/svg%3E") no-repeat right 18px center;
          width: 100%;
          cursor: pointer;
          color: #2d3748;
          font-weight: 500;
          padding-right: 45px;
        }

        .country-select:focus {
          outline: none;
          border-color: #fd7e14;
          box-shadow: 0 0 0 3px rgba(253, 126, 20, 0.1);
        }

        .country-flag {
          position: absolute;
          left: 18px;
          top: 50%;
          transform: translateY(-50%);
          width: 28px;
          height: 21px;
          border-radius: 3px;
          object-fit: cover;
          pointer-events: none;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        /* Phone Input Custom Styling */
        .phone-input-wrapper .react-tel-input {
          font-family: inherit;
        }

        .phone-input-wrapper .react-tel-input .form-control {
          width: 100%;
          padding: 16px 18px 16px 58px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 16px;
          font-family: inherit;
          transition: all 0.3s ease;
          background: white;
          height: auto;
          color: #2d3748;
          font-weight: 500;
        }

        .phone-input-wrapper .react-tel-input .form-control:focus {
          outline: none;
          border-color: #fd7e14;
          box-shadow: 0 0 0 3px rgba(253, 126, 20, 0.1);
        }

        .phone-input-wrapper .react-tel-input .flag-dropdown {
          border: none;
          background: transparent;
        }

        .phone-input-wrapper .react-tel-input .selected-flag {
          padding: 0 0 0 18px;
          border-radius: 12px 0 0 12px;
        }

        .phone-input-wrapper .react-tel-input .selected-flag:hover,
        .phone-input-wrapper .react-tel-input .selected-flag.open {
          background: transparent;
        }

        .file-upload-group {
          margin-top: 8px;
        }

        .file-upload-wrapper input[type="file"] {
          display: none;
        }

        .file-upload-label {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 22px;
          border: 2px dashed #cbd5e0;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: #f7fafc;
          color: #4a5568;
          font-weight: 600;
          font-size: 15px;
        }

        .file-upload-label:hover {
          border-color: #fd7e14;
          background: #fff5f0;
          color: #fd7e14;
        }

        .file-upload-label svg {
          font-size: 26px;
        }

        .form-hint {
          font-size: 14px;
          color: #718096;
          margin-top: 6px;
          font-weight: 500;
        }

        .form-actions {
          display: flex;
          gap: 18px;
          justify-content: flex-end;
          margin-top: 36px;
          padding-top: 36px;
          border-top: 2px solid #e2e8f0;
        }
          
       .form-actions .btn-container {
         background: #2f5d46;      
                    
         border-radius: 8px;       
         display: inline-flex;     
          align-items: center;
        }

        .btn-secondary {
          padding: 16px 32px;
         background: #ffffff;              
         border: none;                     
         border-radius: 12px;
          font-size: 16px;
         font-weight: 700;
         color: #2f5d46;                   
         cursor: pointer;
         transition: all 0.25s ease;
         font-family: inherit;
         display: flex;
         align-items: center;
         gap: 10px;
        }

        .btn-secondary:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .btn-secondary:hover:not(:disabled) {
          background: #e6f4ee;             
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
       }


        .btn-primary {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 18px 36px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .btn-primary:disabled {
          opacity: 0.75;
          cursor: not-allowed;
          transform: none !important;
          box-shadow: none !important;
        }

        .btn-primary:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(253, 126, 20, 0.4);
        }

        /* Spinner animation */
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .btn-spinner {
          animation: spin 0.8s linear infinite;
          font-size: 16px;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .hero-title {
            font-size: 42px;
          }

          .form-container {
            padding: 40px;
          }
        }

        @media (max-width: 768px) {
          .modal-content {
            padding: 32px 24px;
          }

          .selection-cards {
            grid-template-columns: 1fr;
          }

          .hero-title {
            font-size: 36px;
          }

          .form-row {
            grid-template-columns: 1fr;
          }

          .form-container {
            padding: 28px;
            border-radius: 16px;
          }

          .form-actions {
            flex-direction: column;
          }

          .form-actions button {
            width: 100%;
          }
        }

        @media (max-width: 480px) {
          .modal-header h2 {
            font-size: 28px;
          }

          .hero-title {
            font-size: 28px;
            letter-spacing: -1px;
          }

          .form-header h2 {
            font-size: 26px;
          }

          .card-icon {
            width: 64px;
            height: 64px;
            font-size: 28px;
          }

          .form-container {
            padding: 24px;
          }

          .form-section-title {
            font-size: 19px;
          }
        }
      `}</style>

            <Header />
            <div className="devenir-partenaire-wrapper">
                {/* Modal de sélection */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <button
                                className="modal-close"
                                onClick={() => window.history.back()}
                            >
                                <FaTimes />
                            </button>

                            <div className="modal-header">
                                <h2>Choisissez votre profil</h2>
                                <p>Sélectionnez le type de partenariat qui vous correspond</p>
                            </div>

                            <div className="selection-cards">
                                <div
                                    className="selection-card"
                                    onClick={() => handleTypeSelection('consultant')}
                                >
                                    <div className="card-icon consultant-icon">
                                        <FaUser />
                                    </div>
                                    <h3>Consultant</h3>
                                    <p>Rejoignez notre réseau d'experts et partagez votre expertise</p>
                                    <button className="select-btn" type="button">
                                        Choisir ce profil
                                    </button>
                                </div>

                                <div
                                    className="selection-card"
                                    onClick={() => handleTypeSelection('entreprise')}
                                >
                                    <div className="card-icon entreprise-icon">
                                        <FaBuilding />
                                    </div>
                                    <h3>Entreprise / Cabinet</h3>
                                    <p>Collaborez avec CINEF et développez votre activité</p>
                                    <button className="select-btn" type="button">
                                        Choisir ce profil
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Success Message */}
                {formSubmitted && (
                    <div className="success-overlay">
                        <div className="success-message">
                            <FaCheckCircle className="success-icon" />
                            <h3>Candidature envoyée avec succès !</h3>
                            <p>Nous examinerons votre demande et vous contacterons bientôt.</p>
                        </div>
                    </div>
                )}

                {/* Hero Section */}
                {selectedType && (
                    <section className="partner-hero">
                        <div className="hero-background">
                            <div className="floating-shape shape-1"></div>
                            <div className="floating-shape shape-2"></div>
                        </div>

                        <div className="container">
                            <div className="hero-content">
                                <div className="hero-badge">
                                    {selectedType === 'consultant' ? <FaUser /> : <FaBuilding />}
                                    <span>
                                        {selectedType === 'consultant' ? 'Espace Consultant' : 'Espace Entreprise'}
                                    </span>
                                </div>

                                <h1 className="hero-title">
                                    {selectedType === 'consultant'
                                        ? 'Devenez Consultant Partenaire'
                                        : 'Devenez Partenaire CINEF'
                                    }
                                </h1>

                                <p className="hero-description">
                                    {selectedType === 'consultant'
                                        ? 'Rejoignez notre réseau d\'experts et contribuez à la formation de qualité en Afrique'
                                        : 'Collaborez avec CINEF et développez votre visibilité à l\'international'
                                    }
                                </p>
                            </div>
                        </div>
                    </section>
                )}

                {/* Formulaire Section */}
                {selectedType && (
                    <section className="form-section">
                        <div className="container">
                            <div className="form-container">
                                <div className="form-header">
                                    <h2>
                                        {selectedType === 'consultant'
                                            ? 'Formulaire de candidature - Consultant'
                                            : 'Formulaire de candidature - Entreprise'
                                        }
                                    </h2>
                                    <p>Remplissez tous les champs requis pour soumettre votre candidature</p>
                                </div>

                                <form onSubmit={handleSubmit} className="partner-form">
                                    {selectedType === 'consultant' ? (
                                        <>
                                            {/* FORMULAIRE CONSULTANT */}
                                            <div className="form-section-title">
                                                <FaUser />
                                                <h3>Informations personnelles</h3>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label htmlFor="nom">
                                                        Nom <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="nom"
                                                        name="nom"
                                                        value={formData.nom}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="Votre nom"
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="prenom">
                                                        Prénom <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="prenom"
                                                        name="prenom"
                                                        value={formData.prenom}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="Votre prénom"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label htmlFor="pays">
                                                        Pays <span className="required">*</span>
                                                    </label>
                                                    <div className="country-select-wrapper">
                                                        {formData.pays && (
                                                            <img
                                                                src={`https://flagcdn.com/w40/${paysList.find(p => p.name === formData.pays)?.code.toLowerCase()}.png`}
                                                                alt=""
                                                                className="country-flag"
                                                            />
                                                        )}
                                                        <select
                                                            id="pays"
                                                            name="pays"
                                                            value={formData.pays}
                                                            onChange={handleInputChange}
                                                            className="country-select"
                                                            required
                                                        >
                                                            <option value="">Sélectionnez un pays</option>
                                                            {paysList.map((country) => (
                                                                <option key={country.code} value={country.name}>
                                                                    {country.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="form-group phone-input-wrapper">
                                                    <label htmlFor="telephone">
                                                        Téléphone <span className="required">*</span>
                                                    </label>
                                                    <PhoneInput
                                                        country={'bj'}
                                                        value={formData.telephone}
                                                        onChange={handlePhoneChange}
                                                        enableSearch={true}
                                                        searchPlaceholder="Rechercher un pays..."
                                                        containerClass="phone-container"
                                                        inputClass="phone-input"
                                                        buttonClass="phone-button"
                                                        dropdownClass="phone-dropdown"
                                                        preferredCountries={['bj', 'tg', 'ne', 'ci', 'sn', 'ml', 'ga', 'cm']}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="email">
                                                    <FaEnvelope className="label-icon" />
                                                    Email <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="votre.email@exemple.com"
                                                />
                                            </div>

                                            <div className="form-section-title">
                                                <FaBriefcase />
                                                <h3>Informations professionnelles</h3>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="domaineExercice">
                                                    Domaine d'exercice <span className="required">*</span>
                                                </label>
                                                <select
                                                    id="domaineExercice"
                                                    name="domaineExercice"
                                                    value={formData.domaineExercice}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="">Sélectionnez un domaine</option>
                                                    <option value="finance">Finance & Comptabilité</option>
                                                    <option value="rh">Ressources Humaines</option>
                                                    <option value="marketing">Marketing & Communication</option>
                                                    <option value="it">Informatique & Digital</option>
                                                    <option value="management">Management & Leadership</option>
                                                    <option value="juridique">Juridique & Conformité</option>
                                                    <option value="sante">Santé & Sécurité</option>
                                                    <option value="autre">Autre (précisez)</option>
                                                </select>
                                            </div>

                                            {showAutreDomaine && (
                                                <div className="form-group">
                                                    <label htmlFor="autreDomaine">
                                                        Précisez votre domaine <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="autreDomaine"
                                                        name="autreDomaine"
                                                        value={formData.autreDomaine}
                                                        onChange={handleInputChange}
                                                        required={showAutreDomaine}
                                                        placeholder="Entrez votre domaine d'expertise"
                                                    />
                                                </div>
                                            )}

                                            <div className="form-group">
                                                <label htmlFor="anneesExperience">
                                                    Années d'expérience <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    id="anneesExperience"
                                                    name="anneesExperience"
                                                    value={formData.anneesExperience}
                                                    onChange={handleInputChange}
                                                    required
                                                    min="0"
                                                    max="50"
                                                    placeholder="Nombre d'années d'expérience"
                                                />
                                            </div>

                                            <div className="form-section-title">
                                                <FaMapMarkerAlt />
                                                <h3>Localisation</h3>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label htmlFor="ville">
                                                        Ville <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="ville"
                                                        name="ville"
                                                        value={formData.ville}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="Votre ville"
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="quartier">
                                                        Quartier <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="quartier"
                                                        name="quartier"
                                                        value={formData.quartier}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="Votre quartier"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-section-title">
                                                <FaFileAlt />
                                                <h3>Documents & Liens</h3>
                                            </div>

                                            <div className="form-group file-upload-group">
                                                <label htmlFor="cv">
                                                    <FaUpload className="label-icon" />
                                                    CV (PDF) <span className="required">*</span>
                                                </label>
                                                <div className="file-upload-wrapper">
                                                    <input
                                                        type="file"
                                                        id="cv"
                                                        name="cv"
                                                        onChange={handleFileChange}
                                                        accept=".pdf"
                                                        required
                                                    />
                                                    <label htmlFor="cv" className="file-upload-label">
                                                        <FaUpload />
                                                        <span>
                                                            {formData.cv ? formData.cv.name : 'Cliquez pour télécharger votre CV'}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="linkedinConsultant">
                                                    <FaLinkedin className="label-icon" />
                                                    Lien LinkedIn <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="url"
                                                    id="linkedinConsultant"
                                                    name="linkedinConsultant"
                                                    value={formData.linkedinConsultant}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="https://linkedin.com/in/votre-profil"
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {/* FORMULAIRE ENTREPRISE */}
                                            <div className="form-section-title">
                                                <FaBuilding />
                                                <h3>Informations de l'entreprise</h3>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="nomEntreprise">
                                                    Nom du cabinet / entreprise <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="nomEntreprise"
                                                    name="nomEntreprise"
                                                    value={formData.nomEntreprise}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="Nom de votre entreprise"
                                                />
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label htmlFor="nomRepresentant">
                                                        Nom du représentant / DG <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="nomRepresentant"
                                                        name="nomRepresentant"
                                                        value={formData.nomRepresentant}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="Nom complet du représentant"
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="dateCreation">
                                                        <FaCalendar className="label-icon" />
                                                        Date de création <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        id="dateCreation"
                                                        name="dateCreation"
                                                        value={formData.dateCreation}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label htmlFor="email">
                                                        <FaEnvelope className="label-icon" />
                                                        Email <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="contact@entreprise.com"
                                                    />
                                                </div>

                                                <div className="form-group phone-input-wrapper">
                                                    <label htmlFor="telephone">
                                                        Téléphone <span className="required">*</span>
                                                    </label>
                                                    <PhoneInput
                                                        country={'bj'}
                                                        value={formData.telephone}
                                                        onChange={handlePhoneChange}
                                                        enableSearch={true}
                                                        searchPlaceholder="Rechercher un pays..."
                                                        containerClass="phone-container"
                                                        inputClass="phone-input"
                                                        buttonClass="phone-button"
                                                        dropdownClass="phone-dropdown"
                                                        preferredCountries={['bj', 'tg', 'ne', 'ci', 'sn', 'ml', 'ga', 'cm']}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-section-title">
                                                <FaMapMarkerAlt />
                                                <h3>Localisation</h3>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label htmlFor="paysEntreprise">
                                                        Pays <span className="required">*</span>
                                                    </label>
                                                    <div className="country-select-wrapper">
                                                        {formData.paysEntreprise && (
                                                            <img
                                                                src={`https://flagcdn.com/w40/${paysList.find(p => p.name === formData.paysEntreprise)?.code.toLowerCase()}.png`}
                                                                alt=""
                                                                className="country-flag"
                                                            />
                                                        )}
                                                        <select
                                                            id="paysEntreprise"
                                                            name="paysEntreprise"
                                                            value={formData.paysEntreprise}
                                                            onChange={handleInputChange}
                                                            className="country-select"
                                                            required
                                                        >
                                                            <option value="">Sélectionnez un pays</option>
                                                            {paysList.map((country) => (
                                                                <option key={country.code} value={country.name}>
                                                                    {country.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="villeEntreprise">
                                                        Ville <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="villeEntreprise"
                                                        name="villeEntreprise"
                                                        value={formData.villeEntreprise}
                                                        onChange={handleInputChange}
                                                        required
                                                        placeholder="Ville du siège"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-section-title">
                                                <FaBriefcase />
                                                <h3>Motivation</h3>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="motivation">
                                                    Pourquoi souhaitez-vous devenir partenaire CINEF ? <span className="required">*</span>
                                                </label>
                                                <textarea
                                                    id="motivation"
                                                    name="motivation"
                                                    value={formData.motivation}
                                                    onChange={handleInputChange}
                                                    required
                                                    rows="5"
                                                    placeholder="Décrivez vos motivations et vos attentes..."
                                                ></textarea>
                                            </div>

                                            <div className="form-section-title">
                                                <FaGlobe />
                                                <h3>Présence en ligne</h3>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="linkedinEntreprise">
                                                    <FaLinkedin className="label-icon" />
                                                    Lien LinkedIn de l'entreprise <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="url"
                                                    id="linkedinEntreprise"
                                                    name="linkedinEntreprise"
                                                    value={formData.linkedinEntreprise}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="https://linkedin.com/company/votre-entreprise"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="siteWeb">
                                                    <FaGlobe className="label-icon" />
                                                    Site web / Plateforme
                                                </label>
                                                <input
                                                    type="url"
                                                    id="siteWeb"
                                                    name="siteWeb"
                                                    value={formData.siteWeb}
                                                    onChange={handleInputChange}
                                                    placeholder="https://votre-site.com (optionnel)"
                                                />
                                            </div>

                                            <div className="form-group file-upload-group">
                                                <label htmlFor="preuveExistence">
                                                    <FaFileAlt className="label-icon" />
                                                    Preuve d'existence (Registre de commerce, document administratif) <span className="required">*</span>
                                                </label>
                                                <div className="file-upload-wrapper">
                                                    <input
                                                        type="file"
                                                        id="preuveExistence"
                                                        name="preuveExistence"
                                                        onChange={handleFileChange}
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        required
                                                    />
                                                    <label htmlFor="preuveExistence" className="file-upload-label">
                                                        <FaUpload />
                                                        <span>
                                                            {formData.preuveExistence
                                                                ? formData.preuveExistence.name
                                                                : 'Cliquez pour télécharger le document'}
                                                        </span>
                                                    </label>
                                                </div>
                                                <small className="form-hint">Formats acceptés: PDF, JPG, PNG (Max 5MB)</small>
                                            </div>
                                        </>
                                    )}

                                    {/* Boutons de soumission */}
                                    <div className="form-actions">
                                        <div className="btn-container">
                                            <button
                                                type="button"
                                                className="btn-secondary"
                                                onClick={handleChangeProfile}
                                                disabled={isChangingProfile || isLoading}
                                            >
                                                {isChangingProfile ? (
                                                    <>
                                                        <FaSpinner className="btn-spinner" />
                                                        Chargement...
                                                    </>
                                                ) : (
                                                    'Changer de profil'
                                                )}
                                            </button>
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn-primary"
                                            disabled={isLoading || isChangingProfile}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <FaSpinner className="btn-spinner" />
                                                    Envoi en cours...
                                                </>
                                            ) : (
                                                <>
                                                    <FaCheckCircle />
                                                    Soumettre ma candidature
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                )}
            </div>
            <Footer />
        </>
    );
};

export default FormPartners;